import React, { useEffect, useRef, useState } from 'react';
import { useGoogleMaps } from './GoogleMapsProvider';

const AddressFields = ({ 
  adresse = '', 
  ville = '', 
  codePostal = '',
  onChange 
}) => {
  const adresseInputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const { isLoaded } = useGoogleMaps();

  const [localValues, setLocalValues] = useState({
    adresse: adresse,
    ville: ville,
    code_postal: codePostal
  });

  useEffect(() => {
    setLocalValues({
      adresse: adresse,
      ville: ville,
      code_postal: codePostal
    });
  }, [adresse, ville, codePostal]);

  useEffect(() => {
    if (isLoaded && adresseInputRef.current && !autocompleteRef.current) {
      // Initialize Google Places Autocomplete
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        adresseInputRef.current,
        {
          componentRestrictions: { country: 'ca' },
          fields: ['address_components', 'formatted_address'],
          types: ['address']
        }
      );

      // Listen for place selection
      autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();
        
        if (place && place.address_components) {
          let streetNumber = '';
          let route = '';
          let locality = '';
          let postalCode = '';
          
          // Parse address components
          place.address_components.forEach(component => {
            const types = component.types;
            
            if (types.includes('street_number')) {
              streetNumber = component.long_name;
            }
            if (types.includes('route')) {
              route = component.long_name;
            }
            if (types.includes('locality')) {
              locality = component.long_name;
            }
            if (types.includes('postal_code')) {
              postalCode = component.long_name;
            }
          });

          // Construct full address
          const fullAddress = `${streetNumber} ${route}`.trim();

          // Update local state WITHOUT triggering parent onChange immediately
          // This prevents form reset
          setTimeout(() => {
            const newValues = {
              adresse: fullAddress,
              ville: locality,
              code_postal: postalCode
            };
            
            setLocalValues(newValues);
            
            // Notify parent after state update
            if (onChange) {
              onChange(newValues);
            }
          }, 0);
        }
      });
    }
  }, [isLoaded, onChange]);

  const handleFieldChange = (field, value) => {
    const newValues = {
      ...localValues,
      [field]: value
    };
    setLocalValues(newValues);
    
    if (onChange) {
      onChange(newValues);
    }
  };

  return (
    <div className="address-fields-container">
      <div className="form-group full-width">
        <label>Adresse complète *</label>
        <input
          ref={adresseInputRef}
          type="text"
          value={localValues.adresse}
          onChange={(e) => handleFieldChange('adresse', e.target.value)}
          placeholder="Commencez à taper l'adresse..."
          required
          autoComplete="off"
        />
        <small style={{color: '#666', fontSize: '0.85rem'}}>
          🔍 Tapez l'adresse, les champs ville et code postal se rempliront automatiquement
        </small>
      </div>
      
      <div className="address-field-row">
        <div className="address-field" style={{flex: '1'}}>
          <label>Ville *</label>
          <input
            type="text"
            value={localValues.ville}
            onChange={(e) => handleFieldChange('ville', e.target.value)}
            placeholder="Sherbrooke"
            required
          />
        </div>
        <div className="address-field" style={{flex: '0 0 180px'}}>
          <label>Code postal *</label>
          <input
            type="text"
            value={localValues.code_postal}
            onChange={(e) => handleFieldChange('code_postal', e.target.value.toUpperCase())}
            placeholder="J1H 5H3"
            required
            pattern="[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]"
            title="Format: A1A 1A1"
          />
        </div>
      </div>
    </div>
  );
};

export default AddressFields;
